/**
 * Subscribes to Redux store changes that affect routing decisions
 * and calls router.invalidate() when they occur.
 *
 * This bridges the gap between Redux reactivity and TanStack Router's
 * beforeLoad guards (which only run on navigation).
 */
export function syncStoreWithRouter(store, router) {
  const getRouteState = (state) => ({
    workstationSelected: state.dashboard.workstationSelected,
    changePart: state.dashboard.changePart,
    omitPart: state.dashboard.omitPart,
    activePart: state.dashboard.workstation?.active_part?.id,
    activeOrder: state.dashboard.data?.active_manufactoring_order,
  });

  let prevState = getRouteState(store.getState());

  store.subscribe(() => {
    const nextState = getRouteState(store.getState());

    const changed =
      prevState.workstationSelected !== nextState.workstationSelected ||
      prevState.changePart !== nextState.changePart ||
      prevState.omitPart !== nextState.omitPart ||
      prevState.activePart !== nextState.activePart ||
      prevState.activeOrder !== nextState.activeOrder;

    if (changed) {
      prevState = nextState;
      router.invalidate();
    }
  });
}
